const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const aus1 =imageBaseUrl + "mbbsCollege/australia/aus1.png";
const aus2 =imageBaseUrl + "mbbsCollege/australia/aus2.png";
const aus3 =imageBaseUrl + "mbbsCollege/australia/aus3.png";
const aus4 =imageBaseUrl + "mbbsCollege/australia/aus4.png";
const aus5 =imageBaseUrl + "mbbsCollege/australia/aus5.png";
const aus6 =imageBaseUrl + "mbbsCollege/australia/aus6.png";
const aus7 =imageBaseUrl + "mbbsCollege/australia/aus7.png";
const aus8 =imageBaseUrl + "mbbsCollege/australia/aus8.png";
const aus9 =imageBaseUrl + "mbbsCollege/australia/aus9.png";
const aus10 =imageBaseUrl + "mbbsCollege/australia/aus10.png";
const rus1 =imageBaseUrl + "mbbsCollege/russia/rus1.png";
const rus2 =imageBaseUrl + "mbbsCollege/russia/rus2.png";
const rus3 =imageBaseUrl + "mbbsCollege/russia/rus3.png";
const rus4 =imageBaseUrl + "mbbsCollege/russia/rus4.png";
const rus5 =imageBaseUrl + "mbbsCollege/russia/rus5.png";
const rus6 =imageBaseUrl + "mbbsCollege/russia/rus6.png";
const rus7 =imageBaseUrl + "mbbsCollege/russia/rus7.png";
const rus8 =imageBaseUrl + "mbbsCollege/russia/rus8.png";
const rus9 =imageBaseUrl + "mbbsCollege/russia/rus9.png";
const rus10 =imageBaseUrl + "mbbsCollege/russia/rus10.png";
const n1 =imageBaseUrl + "mbbsCollege/nepal/n1.png";
const n2 =imageBaseUrl + "mbbsCollege/nepal/n2.png";
const n3 =imageBaseUrl + "mbbsCollege/nepal/n3.png";
const n4 =imageBaseUrl + "mbbsCollege/nepal/n4.png";
const n5 =imageBaseUrl + "mbbsCollege/nepal/n5.png";
const n6 =imageBaseUrl + "mbbsCollege/nepal/n6.png";
const n7 =imageBaseUrl + "mbbsCollege/nepal/n7.png";
const n8 =imageBaseUrl + "mbbsCollege/nepal/n8.png";
const n9 =imageBaseUrl + "mbbsCollege/nepal/n9.png";
const n10 =imageBaseUrl + "mbbsCollege/nepal/n10.png";
const b1 =imageBaseUrl + "mbbsCollege/bangladesh/b1.png";
const b2 =imageBaseUrl + "mbbsCollege/bangladesh/b2.png";
const b3 =imageBaseUrl + "mbbsCollege/bangladesh/b3.png";
const b4 =imageBaseUrl + "mbbsCollege/bangladesh/b4.png";
const b5 =imageBaseUrl + "mbbsCollege/bangladesh/b5.png";
const b6 =imageBaseUrl + "mbbsCollege/bangladesh/b6.png";
const b7 =imageBaseUrl + "mbbsCollege/bangladesh/b7.png";
const b8 =imageBaseUrl + "mbbsCollege/bangladesh/b8.png";
const b9 =imageBaseUrl + "mbbsCollege/bangladesh/b9.png";
const b10 =imageBaseUrl + "mbbsCollege/bangladesh/b10.png";
const can1 =imageBaseUrl + "mbbsCollege/canada/can1.png";
const can2 =imageBaseUrl + "mbbsCollege/canada/can2.png";
const can3 =imageBaseUrl + "mbbsCollege/canada/can3.png";
const can4 =imageBaseUrl + "mbbsCollege/canada/can4.png";
const can5 =imageBaseUrl + "mbbsCollege/canada/can5.png";
const can6 =imageBaseUrl + "mbbsCollege/canada/can6.png";
const can7 =imageBaseUrl + "mbbsCollege/canada/can7.png";
const can8 =imageBaseUrl + "mbbsCollege/canada/can8.png";
const can9 =imageBaseUrl + "mbbsCollege/canada/can9.png";
const can10 =imageBaseUrl + "mbbsCollege/canada/can10.png";
const ger1 =imageBaseUrl + "mbbsCollege/germany/ger1.png";
const ger2 =imageBaseUrl + "mbbsCollege/germany/ger2.png";
const ger3 =imageBaseUrl + "mbbsCollege/germany/ger3.png";
const ger4 =imageBaseUrl + "mbbsCollege/germany/ger4.png";
const ger5 =imageBaseUrl + "mbbsCollege/germany/ger5.png";
const ger6 =imageBaseUrl + "mbbsCollege/germany/ger6.png";
const ger7 =imageBaseUrl + "mbbsCollege/germany/ger7.png";
const ger8 =imageBaseUrl + "mbbsCollege/germany/ger8.png";
const ger9 =imageBaseUrl + "mbbsCollege/germany/ger9.png";
const ger10 =imageBaseUrl + "mbbsCollege/germany/ger10.png";
const phi1 =imageBaseUrl + "mbbsCollege/philippines/phi1.png";
const phi2 =imageBaseUrl + "mbbsCollege/philippines/phi2.png";
const phi3 =imageBaseUrl + "mbbsCollege/philippines/phi3.png";
const phi4 =imageBaseUrl + "mbbsCollege/philippines/phi4.png";
const phi5 =imageBaseUrl + "mbbsCollege/philippines/phi5.png";
const phi6 =imageBaseUrl + "mbbsCollege/philippines/phi6.png";
const phi7 =imageBaseUrl + "mbbsCollege/philippines/phi7.png";
const phi8 =imageBaseUrl + "mbbsCollege/philippines/phi8.png";
const phi9 =imageBaseUrl + "mbbsCollege/philippines/phi9.png";
const phi10 =imageBaseUrl + "mbbsCollege/philippines/phi10.png";
const us1 =imageBaseUrl + "mbbsCollege/usa/us1.png";
const us2 =imageBaseUrl + "mbbsCollege/usa/us2.png";
const us3 =imageBaseUrl + "mbbsCollege/usa/us3.png";
const us4 =imageBaseUrl + "mbbsCollege/usa/us4.png";
const us5 =imageBaseUrl + "mbbsCollege/usa/us5.png";
const us6 =imageBaseUrl + "mbbsCollege/usa/us6.png";
const us7 =imageBaseUrl + "mbbsCollege/usa/us7.png";
const us8 =imageBaseUrl + "mbbsCollege/usa/us8.png";
const us9 =imageBaseUrl + "mbbsCollege/usa/us9.png";
const us10 =imageBaseUrl + "mbbsCollege/usa/us10.png";
const uk1 =imageBaseUrl + "mbbsCollege/uk/uk1.png";
const uk2 =imageBaseUrl + "mbbsCollege/uk/uk2.png";
const uk3 =imageBaseUrl + "mbbsCollege/uk/uk3.png";
const uk4 =imageBaseUrl + "mbbsCollege/uk/uk4.png";
const uk5 =imageBaseUrl + "mbbsCollege/uk/uk5.png";
const uk6 =imageBaseUrl + "mbbsCollege/uk/uk6.png";
const uk7 =imageBaseUrl + "mbbsCollege/uk/uk7.png";
const uk8 =imageBaseUrl + "mbbsCollege/uk/uk8.png";
const uk9 =imageBaseUrl + "mbbsCollege/uk/uk9.png";
const uk10 =imageBaseUrl + "mbbsCollege/uk/uk10.png";
const kz1 =imageBaseUrl + "mbbsCollege/kazakhstan/kz1.png";
const kz2 =imageBaseUrl + "mbbsCollege/kazakhstan/kz2.png";
const kz3 =imageBaseUrl + "mbbsCollege/kazakhstan/kz3.png";
const kz4 =imageBaseUrl + "mbbsCollege/kazakhstan/kz4.png";
const kz5 =imageBaseUrl + "mbbsCollege/kazakhstan/kz5.png";
const kz6 =imageBaseUrl + "mbbsCollege/kazakhstan/kz6.png";
const kz7 =imageBaseUrl + "mbbsCollege/kazakhstan/kz7.png";
const kz8 =imageBaseUrl + "mbbsCollege/kazakhstan/kz8.png";
const kz9 =imageBaseUrl + "mbbsCollege/kazakhstan/kz9.png";
const kz10 =imageBaseUrl + "mbbsCollege/kazakhstan/kz10.png";
const ky1 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky1.png";
const ky2 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky2.png";
const ky3 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky3.png";
const ky4 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky4.png";
const ky5 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky5.png";
const ky6 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky6.png";
const ky7 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky7.png";
const ky8 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky8.png";
const ky9 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky9.png";
const ky10 =imageBaseUrl + "mbbsCollege/kyrgyzstan/ky10.png";
const uz1 =imageBaseUrl + "mbbsCollege/uzbekistan/uz1.png";
const uz2 =imageBaseUrl + "mbbsCollege/uzbekistan/uz2.png";
const uz3 =imageBaseUrl + "mbbsCollege/uzbekistan/uz3.png";
const uz4 =imageBaseUrl + "mbbsCollege/uzbekistan/uz4.png";
const uz5 =imageBaseUrl + "mbbsCollege/uzbekistan/uz5.png";
const uz6 =imageBaseUrl + "mbbsCollege/uzbekistan/uz6.png";
const uz7 =imageBaseUrl + "mbbsCollege/uzbekistan/uz7.png";
const uz8 =imageBaseUrl + "mbbsCollege/uzbekistan/uz8.png";
const uz9 =imageBaseUrl + "mbbsCollege/uzbekistan/uz9.png";
const uz10 =imageBaseUrl + "mbbsCollege/uzbekistan/uz10.png";

const RussiaMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Russia",
  content: [
    {
      title: "KSMU",

      items: [
        "Kazan State Medical University",
        "Location:- Kazan",
        "Annual Fee:- ₹3,00,000 - ₹5,00,000",
      ],
      Image: rus1,
    },
    {
      title: "RUDN University",

      items: [
        "Peoples' Friendship University of Russia (RUDN University) ",
        "Location:- Moscow",
        "Annual Fee:- ₹3,50,000 - ₹6,00,000",
      ],
      Image: rus2,
    },
    {
      title: "RNRMU",

      items: [
        "Russian National Research Medical University (RNRMU or RSMU)",
        "Location:- Moscow",
        "Annual Fee:- ₹4,00,000 - ₹6,50,000",
      ],
      Image: rus3,
    },
    {
      title: "MSMU",

      items: [
        "Moscow State Medical University",
        "Location:- Moscow",
        "Annual Fee:- ₹3,50,000 - ₹6,00,000",
      ],
      Image: rus4,
    },
    {
      title: "FMSMU",

      items: [
        "First Moscow State Medical University (Sechenov University)",
        "Location:- Moscow",
        "Annual Fee:- ₹3,50,000 - ₹6,00,000",
      ],
      Image: rus5,
    },
    {
      title: "NSMU",

      items: [
        "Northern State Medical University",
        "Location:- Arkhangelsk",
        "Annual Fee:- ₹3,00,000 - ₹5,00,000",
      ],
      Image: rus6,
    },
    {
      title: "TSMU",

      items: [
        "Tver State Medical University, Tver",
        "Location:- Tver",
        "Annual Fee:- ₹2,50,000 - ₹4,50,000",
      ],
      Image: rus7,
    },
    {
      title: "SPSPMU",

      items: [
        "Saint Petersburg State Pediatric Medical University (SPSPMU)",
        "Location:- St. Petersburg",
        "Annual Fee:- ₹3,00,000 - ₹5,00,000",
      ],
      Image: rus8,
    },
    {
      title: "BSMU",

      items: [
        "Bashkir State Medical University",
        "Location:- Ufa",
        "Annual Fee:- ₹2,50,000 - ₹4,50,000",
      ],
      Image: rus9,
    },
    {
      title: "ISMU",

      items: [
        "Irkutsk State Medical University",
        "Location:- Irkutsk",
        "Annual Fee:- ₹2,50,000 - ₹4,50,000",
      ],
      Image: rus10,
    },
    // {
    //     title: "IKBFU",

    //     items: [

    //         "IMMANUEL KANT BALTIC FEDERAL UNIVERSITY, KALININGRAD",
    //         "258532-350000"
    //     ],
    //     Image: rus11,
    // },
  ],
};
const BangladeshMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Bangladesh",
  content: [
    {
      title: "DMC",

      items: [
        "Dhaka Medical College",
        "Location:- Dhaka",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b1,
    },
    {
      title: "SSMC",

      items: [
        "Sir Salimullah Medical College",
        "Location:- Dhaka",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b2,
    },
    {
      title: "SSMC",

      items: [
        "Shaheed Suhrawardy Medical College",
        "Location:- Dhaka",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b3,
    },
    {
      title: "CMC",

      items: [
        "Chittagong Medical College",
        "Location:- Chittagong",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b4,
    },
    {
      title: "MMC",

      items: [
        "Mymensingh Medical College",
        "Location:- Mymensingh",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b5,
    },
    {
      title: "RMC",

      items: [
        "Rajshahi Medical College",
        "Location:- Rajshahi",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b6,
    },
    {
      title: "CMC",

      items: [
        "Comilla Medical College",
        "Location:- Comilla",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b7,
    },
    {
      title: "KMC",

      items: [
        "Khulna Medical College",
        "Location:- Khulna",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b8,
    },
    {
      title: "RMC",

      items: [
        "Rangpur Medical College",
        "Location:- Rangpur",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b9,
    },
    {
      title: "SMOMC",

      items: [
        "Sylhet MAG Osmani Medical College",
        "Location:- Sylhet",
        "Annual Fee:- ₹5,52,000",
      ],
      Image: b10,
    },
  ],
};
const CanadaMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Canada",
  content: [
    {
      title: "UOT",

      items: [
        "University of Toronto,Toronto",
        "Location:- Ontario",
        "Annual Fee:- ₹27,50,000 - ₹44,00,000",
      ],
      Image: can1,
    },
    {
      title: "UBC",

      items: [
        "University of British Columbia (UBC),Vancouver",
        "Location:- British Columbia",
        "Annual Fee:- ₹16,50,000 - ₹33,00,00",
      ],
      Image: can2,
    },
    {
      title: "MUM",

      items: [
        "McGill University,Montreal",
        "Location:- Quebec",
        "Annual Fee:- ₹16,50,000 - ₹33,00,000",
      ],
      Image: can3,
    },
    {
      title: "UOA",

      items: [
        "University of Alberta",
        "Location:- Edmonton",
        "Annual Fee:- ₹11,00,000 - ₹22,00,000",
      ],
      Image: can4,
    },
    {
      title: "MU",

      items: [
        "McMaster University,Hamilton",
        "Location:- Ontario",
        "Annual Fee:- ₹16,50,000 - ₹27,50,000",
      ],
      Image: can5,
    },
    {
      title: "UOO",

      items: [
        "University of Ottawa,Ottawa",
        "Location:- Ontario",
        "Annual Fee:- ₹11,00,000 - ₹22,00,000",
      ],
      Image: can6,
    },
    {
      title: "UOC",

      items: [
        "University of Calgary,Calgary",
        "Location:- Alberta",
        "Annual Fee:- ₹11,00,000 - ₹22,00,000",
      ],
      Image: can7,
    },
    {
      title: "WU",

      items: [
        "Western University,London",
        "Location:- Ontario",
        "Annual Fee:- ₹11,00,000 - ₹22,00,000",
      ],
      Image: can8,
    },
    {
      title: "QU",

      items: [
        "Queen's University,Kingston",
        "Location:- Ontario",
        "Annual Fee:- ₹16,50,000 - ₹27,50,000",
      ],
      Image: can9,
    },
    {
      title: "DU",

      items: [
        "Dalhousie University,Halifax",
        "Location:- Nova Scotia",
        "Annual Fee:- ₹11,00,000 - ₹22,00,000",
      ],
      Image: can10,
    },
  ],
};
const GermanyMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Germany",
  content: [
    {
      title: "CUB",

      items: [
        "Charité - Universitätsmedizin Berlin",
        "Location:- Berlin",
        "Annual Fee:- ₹17,40,000 - ₹26,10,000",
      ],
      Image: ger1,
    },
    {
      title: "RKUH",

      items: [
        "Ruprecht-Karls-Universität Heidelberg (Heidelberg University)",
        "Location:- Heidelberg",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger2,
    },
    {
      title: "LMUM",

      items: [
        "Ludwig-Maximilians-Universität München (LMU Munich)",
        "Location:- Munich",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger3,
    },
    {
      title: "EKUT",

      items: [
        "Eberhard Karls Universität Tübingen (University of Tübingen),",
        "Location:- Tübingen",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger4,
    },
    {
      title: "FUOB",

      items: [
        "Freie Universität Berlin (Free University of Berlin)",
        "Location:- Berlin",
        "Annual Fee:- ₹17,40,000 - ₹26,10,000",
      ],
      Image: ger5,
    },
    {
      title: "UOB",

      items: [
        "Universität Bonn (University of Bonn)",
        "Location:- Bonn",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger6,
    },
    {
      title: "TUOB",

      items: [
        "Technische Universität München (Technical University of Munich)",
        "Location:- Munich",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger7,
    },
    {
      title: "UOF",

      items: [
        "Universität Freiburg (University of Freiburg)",
        "Location:- Freiburg",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger8,
    },
    {
      title: "GUF",

      items: [
        "Universität Frankfurt am Main (Goethe University Frankfurt)",
        "Location:- Frankfurt",
        "Annual Fee:- ₹17,40,000 - ₹26,10,000",
      ],
      Image: ger9,
    },
    {
      title: "UOL",

      items: [
        "Universität Leipzig (University of Leipzig)",
        "Location:- Leipzig",
        "Annual Fee:- ₹8,70,000 - ₹17,40,000",
      ],
      Image: ger10,
    },
  ],
};
const PhilippinesMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Philippines",
  content: [
    {
      title: "UOST",

      items: ["University of Santo Tomas,Manila", "₹2,94,000 - ₹4,41,000"],
      Image: phi1,
    },
    {
      title: "UOPM",

      items: [
        "University of the Philippines Manila (UP Manila)",
        "Location:- Manila",
        "Annual Fee:- ₹2,21,000 - ₹3,68,500",
      ],
      Image: phi2,
    },
    {
      title: "CIOM",

      items: [
        "Cebu Institute of Medicine",
        "Location:- Cebu City",
        "Annual Fee:- ₹2,21,000 - ₹2,94,000",
      ],
      Image: phi3,
    },
    {
      title: "PLM",

      items: [
        "Pamantasan ng Lungsod ng Maynila (PLM)",
        "Location:- Manila",
        "Annual Fee:- ₹1,17,600 - ₹1,76,400",
      ],
      Image: phi4,
    },
    {
      title: "MCUCOM",

      items: [
        "Manila Central University College of Medicine",
        "Location:- Manila",
        "Annual Fee:- ₹1,76,400 - ₹2,64,600",
      ],
      Image: phi5,
    },
    {
      title: "DSMHSI",

      items: [
        "De La Salle Medical and Health Sciences Institute",
        "Location:- Dasmarinas",
        "Annual Fee:- ₹2,21,000 - ₹2,94,000",
      ],
      Image: phi6,
    },
    {
      title: "ASMPH",

      items: [
        "Ateneo School of Medicine and Public Health",
        "Location:- Pasig City",
        "Annual Fee:- ₹2,94,000 - ₹4,41,000",
      ],
      Image: phi7,
    },
    {
      title: "FEU",

      items: [
        "Far Eastern University (FEU) Institute of Medicine",
        "Location:- Manila",
        "Annual Fee:- ₹2,94,000 - ₹4,41,000",
      ],
      Image: phi8,
    },
    {
      title: "SLUCOM",

      items: [
        "Saint Louis University College of Medicine",
        "Location:- Baguio City",
        "Annual Fee:- ₹1,76,400 - ₹2,64,600",
      ],
      Image: phi9,
    },
    {
      title: "UPHRJFSM",

      items: [
        "University of Perpetual Help Rizal Jonelta Foundation School of Medicine",
        "Location:- Calamba City",
        "Annual Fee:- ₹1,76,400 - ₹2,64,600",
      ],
      Image: phi10,
    },
  ],
};
const AustraliaMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Australia",
  content: [
    {
      title: "UOM",

      items: [
        "University of Melbourne",
        "Location:- Melbourne",
        "Annual Fee:- ₹3,773,520",
      ],
      Image: aus1,
    },

    {
      title: "UOS",

      items: [
        "University of Sydney",
        "Location:- Sydney",
        "Annual Fee:- ₹3,825,920",
      ],
      Image: aus2,
    },
    {
      title: "UOQ",

      items: [
        "University of Queensland",
        "Location:- Brisbane",
        "Annual Fee:- ₹3,620,000",
      ],
      Image: aus3,
    },
    {
      title: "UNSW",

      items: [
        "University of New South Wales (UNSW Sydney)",
        "Location:- Sydney",
        "Annual Fee:- ₹3,624,960",
      ],
      Image: aus4,
    },
    {
      title: "UWA",

      items: [
        "University of Western Australia (UWA)",
        "Location:- Brisbane",
        "Annual Fee:- ₹3,620,000",
      ],
      Image: aus5,
    },
    {
      title: "MU",

      items: [
        "Monash University",
        "Location:- Melbourne",
        "Annual Fee:- ₹3,745,000",
      ],
      Image: aus6,
    },
    {
      title: "UOA",

      items: [
        "University of Adelaide",
        "Location:- Adelaide",
        "Annual Fee:- ₹3,696,800",
      ],
      Image: aus7,
    },
    {
      title: "UOS",

      items: [
        "University of Sydney - Westmead",
        "Location:- Sydney",
        "Annual Fee:- ₹3,825,920",
      ],
      Image: aus8,
    },
    {
      title: "GUMS",

      items: [
        "Griffith University,Brisbane",
        "Location:- Brisbane",
        "Annual Fee:- ₹3,776,800",
      ],
      Image: aus9,
    },
    {
      title: "ANU",

      items: [
        "Australian National University (ANU)",
        "Location:- Canberra",
        "Annual Fee:- ₹3,620,000",
      ],
      Image: aus10,
    },
  ],
};
const NepalMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN Nepal",
  content: [
    {
      title: "IOM",

      items: [
        "Institute of Medicine (IOM), Tribhuvan University",
        "Location:- Kathmandu",
        "Annual Fee:- ₹18,48,000",
      ],
      Image: n1,
    },
    {
      title: "KUSMS",

      items: [
        "Kathmandu University School of Medical Sciences (KUSMS)",
        "Location:- Dhulikhel",
        "Annual Fee:- ₹15,40,000",
      ],
      Image: n2,
    },
    {
      title: "BPKIHS",

      items: [
        "BP Koirala Institute of Health Sciences (BPKIHS)",
        "Location:- Dharan",
        "Annual Fee:- ₹12,32,000",
      ],
      Image: n3,
    },
    {
      title: "NMC",

      items: [
        "Nepal Medical College (NMC)",
        "Location:- Kathmandu",
        "Annual Fee:- ₹11,08,800",
      ],
      Image: n4,
    },
    {
      title: "PAHS",

      items: [
        "Patan Academy of Health Sciences (PAHS)",
        "Location:- Lalitpur",
        "Annual Fee:- ₹10,48,400",
      ],
      Image: n5,
    },
    {
      title: "NMC",

      items: [
        "Nobel Medical College",
        "Location:- Biratnagar",
        "Annual Fee:- ₹9,24,000",
      ],
      Image: n6,
    },
    {
      title: "UCMS",

      items: [
        "Universal College of Medical Sciences (UCMS)",
        "Location:- Bhairahawa",
        "Annual Fee:- ₹9,24,000",
      ],
      Image: n7,
    },
    {
      title: "MCOMS",

      items: [
        "Manipal College of Medical Sciences (MCOMS)",
        "Location:- Pokhara",
        "Annual Fee:- ₹8,01,600",
      ],
      Image: n8,
    },
    {
      title: "CMC",

      items: [
        "Chitwan Medical College (CMC)",
        "Location:- Bharatpur",
        "Annual Fee:- ₹7,38,000",
      ],
      Image: n9,
    },
    {
      title: "NGMC",

      items: [
        "Nepalgunj Medical College (NGMC)",
        "Location:- Nepalgunj",
        "Annual Fee:- ₹7,38,000",
      ],
      Image: n10,
    },
  ],
};
const USAMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN USA",
  content: [
    {
      title: "HMS",

      items: [
        "Harvard Medical School",
        "Location:- Boston",
        "Annual Fee:- INR 47,55,000",
      ],
      Image: us1,
    },
    {
      title: "JHUSM",

      items: [
        "Johns Hopkins University School of Medicine",
        "Location:- Baltimore, MD",
        "Annual Fee:- INR 45,67,500",
      ],
      Image: us2,
    },
    {
      title: "SUSM",

      items: [
        "Stanford University School of Medicine",
        "Location:- Stanford, CA",
        "Annual Fee:- INR 46,40,625",
      ],
      Image: us3,
    },
    {
      title: "UCSF",

      items: [
        "University of California, San Francisco (UCSF)",
        "Location:- San Francisco, CA",
        "Annual Fee:- INR 43,35,600",
      ],
      Image: us4,
    },
    {
      title: "CUVCPS",

      items: [
        "Columbia University Vagelos College of Physicians and Surgeons",
        "Location:- New York, NY",
        "Annual Fee:- INR 51,65,950",
      ],
      Image: us5,
    },
    {
      title: "PSMUP",

      items: [
        "Perelman School of Medicine University, Pennsylvania",
        "Location:- Philadelphia, PA",
        "Annual Fee:- INR 50,86,050",
      ],
      Image: us6,
    },
    {
      title: "WUSMSL",

      items: [
        "Washington University School of Medicine in St. Louis",
        "Location:- St. louis, MO",
        "Annual Fee:- INR 48,61,800",
      ],
      Image: us7,
    },
    {
      title: "MCASM",

      items: [
        "Mayo Clinic Alix School of Medicine",
        "Location:- Rochester, MN",
        "Annual Fee:- INR 46,03,850",
      ],
      Image: us8,
    },
    {
      title: "YSM",

      items: [
        "Yale School of Medicine",
        "Location:- New Haven, CT",
        "Annual Fee:- INR 47,23,050",
      ],
      Image: us9,
    },
    {
      title: "NYUG",

      items: [
        "New York University Grossman School of Medicine",
        "Location:- New York, NY",
        "Annual Fee:- INR 47,42,875",
      ],
      Image: us10,
    },
  ],
};
const UKMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN UK",
  content: [
    {
      title: "UOMS",

      items: [
        "University of Oxford Medical School",
        "Location:- Oxford, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk1,
    },
    {
      title: "UCSCM",

      items: [
        "University of Cambridge School of Clinical Medicine",
        "Location:- Cambridge, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk2,
    },
    {
      title: "UCL",

      items: [
        "University College London (UCL) Medical School",
        "Location:- London, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk3,
    },
    {
      title: "ICLFM",

      items: [
        "Imperial College London Faculty of Medicine",
        "Location:- London, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk4,
    },
    {
      title: "UEMS",

      items: [
        "University of Edinburgh Medical School",
        "Location:- Edinburgh, Scotland",
        "Annual Fee:- ₹25,00,000 - ₹30,00,000",
      ],
      Image: uk5,
    },
    {
      title: "KCLGSME",

      items: [
        "King's College London GKT School of Medical Education",
        "Location:- London, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk6,
    },
    {
      title: "UMMS",

      items: [
        "University of Manchester Medical School",
        "Location:- Manchester, England",
        "Annual Fee:- ₹25,00,000 - ₹30,00,000",
      ],
      Image: uk7,
    },
    {
      title: "UGSM",

      items: [
        "University of Glasgow School of Medicine",
        "Location:- Glasgow, Scotland",
        "Annual Fee:- ₹25,00,000 - ₹30,00,000",
      ],
      Image: uk8,
    },
    {
      title: "UBMS",

      items: [
        "University of Bristol Medical School",
        "Location:- Bristol, England",
        "Annual Fee:- ₹30,00,000 - ₹35,00,000",
      ],
      Image: uk9,
    },
    {
      title: "UBMS",

      items: [
        "University of Birmingham Medical School, Birmingham, England",
        "Location:- Birmingham, England",
        "Annual Fee:- ₹25,00,000 - ₹30,00,000",
      ],
      Image: uk10,
    },
  ],
};
const KazakhstanMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN KAZAKHSTAN",
  content: [
    {
      title: "KSMU",

      items: [
        "Karaganda State Medical University",
        "Location:- Karaganda",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz1,
    },
    {
      title: "AMU",

      items: [
        "Astana Medical University",
        "Location:- Nur-Sultan",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz2,
    },
    {
      title: "SSMU",

      items: [
        "Semey State Medical University",
        "Location:- Semey",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz3,
    },
    {
      title: "WKMOSMU",

      items: [
        "West Kazakhstan Marat Ospanov State Medical University",
        "Location:- AKtobe",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz4,
    },
    {
      title: "SKMA",

      items: [
        "South Kazakhstan Medical Academy, Shymkent",
        "Location:- Shymkent",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz5,
    },
    {
      title: "KNMU",

      items: [
        "Kazakh National Medical University",
        "Location:- Almaty",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz6,
    },
    {
      title: "KSU",

      items: [
        "Kokshetau State University named after Shokan Ualikhanov",
        "Location:- Kokshetau",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz7,
    },
    {
      title: "KMU",

      items: [
        "Karaganda Medical University",
        "Location:- Karaganda",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz8,
    },
    {
      title: "KRMU",

      items: [
        "Kazakh-Russian Medical University",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz9,
    },
    {
      title: "NKSU",

      items: [
        "North Kazakhstan State University named after Manash Kozybayev",
        "Location:- Petropavl",
        "Annual Fee:- ₹2,25,000 - ₹5,25,000",
      ],
      Image: kz10,
    },
  ],
};
const KyrgyzstanMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN KYRGYZSTAN",
  content: [
    {
      title: "ISM",

      items: [
        "International School of Medicine",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky1,
    },
    {
      title: "KSMA",

      items: [
        "Kyrgyz State Medical Academy",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky2,
    },
    {
      title: "JSU",

      items: [
        "Jalal-Abad State University",
        "Location:- Jalal-Abad",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky3,
    },
    {
      title: "OSU",

      items: [
        "Osh State University, Osh",
        "Location:- Osh",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky4,
    },
    {
      title: "AMI",

      items: [
        "Asian Medical Institute",
        "Location:- Kant",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky5,
    },
    {
      title: "IMU",

      items: [
        "International Medical University",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky6,
    },
    {
      title: "KRSU",

      items: [
        "Kyrgyz Russian Slavic University",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky7,
    },
    {
      title: "KSMI",

      items: [
        "Kyrgyz State Medical Institute",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky8,
    },
    {
      title: "KNU",

      items: [
        "Kyrgyz National University",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky9,
    },
    {
      title: "KSAPCS",

      items: [
        "Kyrgyz State Academy of Physical Culture and Sports",
        "Location:- Bishkek",
        "Annual Fee:- ₹1,87,500 - ₹3,75,000",
      ],
      Image: ky10,
    },
  ],
};
const UzbekistanMbbsCollege = {
  heading: "TOP 10 COLLEGES FOR MBBS IN UZBEKISTAN",
  content: [
    {
      title: "TMA",

      items: [
        "Tashkent Medical Academy",
        "Location:- Tashkent",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz1,
    },
    {
      title: "SSMI",

      items: [
        "Samarkand State Medical Institute",
        "Location:- Samarkand",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz2,
    },
    {
      title: "ASMI",

      items: [
        "Andijan State Medical Institute",
        "Location:- Andijan",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz3,
    },
    {
      title: "BSMI",

      items: [
        "Bukhara State Medical Institute",
        "Location:- Bukhara",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz4,
    },
    {
      title: "KSMI",

      items: [
        "Karakalpak State Medical Institute",
        "Location:- Nukus",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz5,
    },
    {
      title: "FSUMF",

      items: [
        "Fergana State University Medical Faculty",
        "Location:- Fergana",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz6,
    },
    {
      title: "NSMI",

      items: [
        "Namangan State Medical Institute",
        "Location:- Namangan",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz7,
    },
    {
      title: "TSUMF",

      items: [
        "Termez State University Medical Faculty",
        "Location:- Termez",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz8,
    },
    {
      title: "USUMF",

      items: [
        "Urgench State University Medical Faculty",
        "Location:- Urgench",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz9,
    },
    {
      title: "TPMI",

      items: [
        "Tashkent Pediatric Medical Institute",
        "Location:- Tashkent",
        "Annual Fee:- ₹1,50,000 - ₹3,75,000",
      ],
      Image: uz10,
    },
  ],
};

export {
  UzbekistanMbbsCollege,
  KyrgyzstanMbbsCollege,
  KazakhstanMbbsCollege,
  RussiaMbbsCollege,
  UKMbbsCollege,
  BangladeshMbbsCollege,
  CanadaMbbsCollege,
  GermanyMbbsCollege,
  PhilippinesMbbsCollege,
  NepalMbbsCollege,
  AustraliaMbbsCollege,
  USAMbbsCollege,
};
